import profileService from "@/services/profile";

export default {
  data() {
    return {
      advProfiles: []
    }
  },
  methods: {
    getProfileTypes() {
      const vue = this;
      profileService
        .getProfileTypes()
        .then(function(response) {
          // handle success
          if (response.success) {
            vue.advProfiles = response.data;
          } else {
            vue.message = vue.$t('error-website');
          }
        })
        .catch(function(error) {
          vue.message = vue.$t('error-website');
        });
    },

    getCountries() {
      const vue = this;
      profileService
        .getCountries()
        .then(function(response) {
          // handle success
          if (response.success) {
            const countries = response.data.map((item) => {
              return {
                value: item.pkIxCountriesIso3166,
                text: item.name,
              };
            });
            vue.countries = countries;
          } else {
            vue.message = vue.$t('error-website');
          }
        })
        .catch(function(error) {
          vue.message = vue.$t('error-website');
        });
    },
  },
};
